import './Program_table.css';


const Portfolio = () => {




  return (

    <table border="0" cellPadding="0" cellSpacing="0" id="sheet0" className="sheet0 gridlines">
      <col className="col0" />
      <col className="col1" />
      <col className="col2" />
      <col className="col3" />
      <col className="col4" />
      <col className="col5" />
      <tbody>
        <tr className="row0">
          <td className="column0 style6 null"></td>
          <td className="column1 style6 null"></td>
          <td className="column2 style6 null"></td>
          <td className="column3 style6 null"></td>
          <td className="column4 style6 null"></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row1">
          <td className="column0">&nbsp;</td>
          <td className="column1 style3 s">Date</td>
          <td className="column2 style3 s">Time</td>
          <td className="column3 style3 s">Events</td>
          <td className="column4 style3 s">Location</td>
          <td className="column5 style7 null"></td>
        </tr>
        <tr className="row2">
          <td className="column0">&nbsp;</td>
          <td className="column1">&nbsp;</td>
          <td className="column2">&nbsp;</td>
          <td className="column3">&nbsp;</td>
          <td className="column4">&nbsp;</td>
          <td className="column5">&nbsp;</td>
        </tr>
        <tr className="row3">
          <td className="column0 style6 null"></td>
          <td className="column1 style12 s style12" rowSpan="2">August 23th</td>
          <td className="column2 style4 s">13:30-18:00</td>
          <td className="column3 style5 s">Onsite Registration &amp;<br />Online Information Desk</td>
          <td className="column4 style5 s">Hotel Lobby &amp;<br />Online Information Desk</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row4">
          <td className="column0 style6 null"></td>
          <td className="column2 style4 s">17:00-20:00</td>
          <td className="column3 style5 s">Welcome Reception</td>
          <td className="column4 style5 s">Jin Yue Western Restaurant<br /><span style={{ color: '#000000', fontFamily: '宋体', fontSize: '11pt' }}>(锦悦西餐厅)</span></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row5">
          <td className="column0 style6 null"></td>
          <td className="column1 style6 null"></td>
          <td className="column2 style6 null"></td>
          <td className="column3 style6 null"></td>
          <td className="column4 style6 null"></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row6">
          <td className="column0 style6 null"></td>
          <td className="column1 style12 s style12" rowSpan="10">August 24th</td>
          <td className="column2 style4 s">08:30 - 08:40</td>
          <td className="column3 style4 s">Opening Ceremony</td>
          <td className="column4 style13 s style14" rowSpan="5">Multifunction Hall<br /><span style={{ color: '#000000', fontFamily: '宋体', fontSize: '11pt' }}>（多功能厅）<br /></span><span style={{ color: '#000000', fontFamily: 'Times New Roman', fontSize: '11pt' }}><br />Online Room:<br />Tecent Meeting: 526-374-324<br /></span></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row7">
          <td className="column0 style6 null"></td>
          <td className="column2 style4 s">08:40 - 09:40</td>
          <td className="column3 style4 s">Plenary Speech I</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row8">
          <td className="column0 style6 null"></td>
          <td className="column2 style4 s">09:40 - 10:00</td>
          <td className="column3 style9 s">Photo Session &amp; <br />Tea/Coffee Break</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row9">
          <td className="column0 style6 null"></td>
          <td className="column2 style4 s">10:00 - 11:00</td>
          <td className="column3 style4 s">Plenary Speech II</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row10">
          <td className="column0 style6 null"></td>
          <td className="column2 style4 s">11:00 - 12:00</td>
          <td className="column3 style4 s">Plenary Speech III</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row11">
          <td className="column0 style6 null"></td>
          <td className="column2 style15 s style17" colSpan="3">Lunch Break</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row12">
          <td className="column0 style6 null"></td>
          <td className="column2 style4 s">13:00 - 14:00</td>
          <td className="column3 style11 s">Invited Talk</td>
          <td className="column4 style5 s">Online Room:<br />Tecent Meeting: 526-374-324</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row13">
          <td className="column0 style6 null"></td>
          <td className="column2 style4 s">13:20 - 18:00</td>
          <td className="column3 style5 s">Parallel Sessions<br />(Four parallel onsite/online oral sessions, please refer to the next page for detailed technical program schedule)</td>
          <td className="column4 style5 s">Jingya Ge (<span style={{ color: '#000000', fontFamily: '宋体', fontSize: '11pt' }}>静雅阁</span><span style={{ color: '#000000', fontFamily: 'Times New Roman', fontSize: '11pt' }}>)<br />Lanting Ge</span> (<span style={{ color: '#000000', fontFamily: '宋体', fontSize: '11pt' }}>兰亭阁</span><span style={{ color: '#000000', fontFamily: 'Times New Roman', fontSize: '11pt' }}>)<br />Online Room 1<br />Online Room 2</span></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row14">
          <td className="column0 style6 null"></td>
          <td className="column2 style15 s style17" colSpan="3">Tea/Coffee Breaks for Parallel Sessions: 15:00-15:20</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row15">
          <td className="column0 style6 null"></td>
          <td className="column2 style4 s">18:00 - 20:00</td>
          <td className="column3 style4 s">Award Banquet</td>
          <td className="column4 style5 s">Multifunction Hall<br /><span style={{ color: '#000000', fontFamily: '宋体', fontSize: '11pt' }}>（多功能厅）</span></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row16">
          <td className="column0 style6 null"></td>
          <td className="column1 style6 null"></td>
          <td className="column2 style6 null"></td>
          <td className="column3 style6 null"></td>
          <td className="column4 style10 null"></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row17">
          <td className="column0 style6 null"></td>
          <td className="column1 style22 s style24" rowSpan="3">August 25th</td>
          <td className="column2 style8 s">09:00 - 12:00</td>
          <td className="column3 style5 s">Parallel Sessions<br />(Four parallel onsite/online oral sessions, please refer to the next page for detailed technical program schedule)</td>
          <td className="column4 style5 s">Jingya Ge (<span style={{ color: '#000000', fontFamily: '宋体', fontSize: '11pt' }}>静雅阁</span><span style={{ color: '#000000', fontFamily: 'Times New Roman', fontSize: '11pt' }}>)<br />Lanting Ge</span> (<span style={{ color: '#000000', fontFamily: '宋体', fontSize: '11pt' }}>兰亭阁</span><span style={{ color: '#000000', fontFamily: 'Times New Roman', fontSize: '11pt' }}>)<br />Online Room 1<br />Online Room 2</span></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row18">
          <td className="column0 style6 null"></td>
          <td className="column2 style18 s style21" colSpan="3" rowSpan="2">Tea/Coffee Breaks for Parallel Sessions: 10:00-10:20</td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row19">
          <td className="column0 style6 null"></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row20">
          <td className="column0 style6 null"></td>
          <td className="column1 style4 s">August 26th</td>
          <td className="column2 style4 null"></td>
          <td className="column3 style5 s">Post-event Activities and Tour<br />(Free activities, self-pay, not officially organized)</td>
          <td className="column4 style4 null"></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row21">
          <td className="column0 style6 null"></td>
          <td className="column1 style6 null"></td>
          <td className="column2 style6 null"></td>
          <td className="column3 style6 null"></td>
          <td className="column4 style6 null"></td>
          <td className="column5 style6 null"></td>
        </tr>
        <tr className="row22">
          <td className="column0 style6 null"></td>
          <td className="column1 style6 null"></td>
          <td className="column2 style6 null"></td>
          <td className="column3 style6 null"></td>
          <td className="column4 style6 null"></td>
          <td className="column5 style6 null"></td>
        </tr>
      </tbody>
    </table>







  )
}

export default Portfolio